import {
  REBALANCE_ACTIONS,
  REBALANCE_DEFAULT_MIN_UNSOLD,
  REBALANCE_MIN_UNSOLD,
} from '../InventoryPage/inventoryData';

const STORAGE_KEY = 'pms.rebalance.excluded-room-types';
const ACTION_STORAGE_KEY = 'pms.rebalance.action';
const MIN_UNSOLD_STORAGE_KEY = 'pms.rebalance.min-unsold';

/** 建議篩選的「不篩選」值。空字串而非 null —— antd 的 Select 用它才選得到「全部建議」那一項。 */
export const REBALANCE_ACTION_ALL = '';

/**
 * 待調控清單的個人化條件 (排除的房型、建議篩選、未售數量門檻)，存在瀏覽器本機。
 *
 * 不做成後端設定：哪些房型該忽略、自己負責哪一種調控、多少間才值得動手，
 * 是個人看清單的習慣，每個人的判斷不同，寫進共用設定反而會互相蓋掉。
 *
 * localStorage 可能因為隱私模式或容量而丟例外，一律吞掉並退回「不過濾」——
 * 顯示得比預期多只是雜訊，因為存取失敗而讓整頁掛掉才是問題。
 */
export function readExcludedRoomTypes() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    // 手改過的內容可能不是陣列，過濾掉非字串避免後續 includes 比對出怪結果
    return Array.isArray(parsed) ? parsed.filter((cod) => typeof cod === 'string') : [];
  } catch (e) {
    return [];
  }
}

export function writeExcludedRoomTypes(codes) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(codes || []));
  } catch (e) {
    // 存不進去就只在這次瀏覽期間生效，不影響畫面
  }
}

/**
 * 建議篩選存的是動作字串本身。認不得的值一律當成「全部建議」——
 * 動作的文字改過之後，舊的存檔會篩不到任何一筆，畫面看起來就跟「今天沒事」
 * 一模一樣，那是最糟的失敗方式。
 */
export function readRebalanceAction() {
  try {
    const raw = window.localStorage.getItem(ACTION_STORAGE_KEY);
    return REBALANCE_ACTIONS.includes(raw) ? raw : REBALANCE_ACTION_ALL;
  } catch (e) {
    return REBALANCE_ACTION_ALL;
  }
}

export function writeRebalanceAction(action) {
  try {
    if (REBALANCE_ACTIONS.includes(action)) {
      window.localStorage.setItem(ACTION_STORAGE_KEY, action);
    } else {
      // 選回「全部建議」時把鍵移掉，而不是存一個空字串 ——
      // 讀取端只要處理「有值」與「沒有值」兩種狀態
      window.localStorage.removeItem(ACTION_STORAGE_KEY);
    }
  } catch (e) {
    // 同上，存不進去不影響這次瀏覽的篩選結果
  }
}

/**
 * 未售數量門檻。低於判定規則的底線 (2 間) 或不是整數的值一律退回預設 3 ——
 * 存進 0 或負數會讓門檻形同虛設，而那是使用者看不出來的。
 */
export function readRebalanceMinUnsold() {
  try {
    const value = Number(window.localStorage.getItem(MIN_UNSOLD_STORAGE_KEY));
    return Number.isInteger(value) && value >= REBALANCE_MIN_UNSOLD
      ? value
      : REBALANCE_DEFAULT_MIN_UNSOLD;
  } catch (e) {
    return REBALANCE_DEFAULT_MIN_UNSOLD;
  }
}

export function writeRebalanceMinUnsold(value) {
  try {
    window.localStorage.setItem(MIN_UNSOLD_STORAGE_KEY, String(value));
  } catch (e) {
    // 同上，存不進去不影響這次瀏覽的篩選結果
  }
}

export const EXCLUDED_ROOM_TYPES_KEY = STORAGE_KEY;
export const REBALANCE_ACTION_KEY = ACTION_STORAGE_KEY;
export const REBALANCE_MIN_UNSOLD_KEY = MIN_UNSOLD_STORAGE_KEY;
